<p-menubar>
  <ng-template pTemplate="start">
    <div class="flex align-items-center justify-content-center w-full md:justify-content-start">
      <a routerLink="/" class="navbar-brand text-secondary">
        <img
          src="assets/img/logos/main_logo.svg"
          class="logo"
          alt="LightCap|Group"
        />
      </a>
    </div>
  </ng-template>
</p-menubar>
